import {
  Box,
  Button,
  Checkbox,
  ListItemIcon,
  ListItemText,
  MenuItem,
  FormControl,
  Select,
  TextField,
} from "@mui/material";
import Layout from "components/structure/Layout";
import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import CommonService from "services/CommonService";
import RoleService from "services/RoleService";
import CheckboxTick from "assets/CheckboxTick.svg";
import CheckboxUntick from "assets/CheckboxUntick.svg";
import { AuthData } from "auth/AuthWarpper";
import { useNavigate } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
import { useTranslation } from "react-i18next";


const AddRole = () => {
  const profileOptions = ["Global", "Local"];
  const { user } = AuthData();
  const navigate = useNavigate();
  const { setOpenAlert, setSeverity, setMessage, handleClose } =
    useContext(SnackbarContext);

  const { t, i18n } = useTranslation()

  const [formData, setFormData] = useState({
    profile: "",
    fieldTechnician: "",
    role: "",
    country: "",
    serviceNumber: "",
    remarks: "",
  });
  const [selected, setSelected] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = React.useState(false);


  const [roleOptions, setRoleOptions] = useState([]);
  const [countries, setCountries] = useState([]);

  const fetchRoles = async (profile, countryCode) => {
    try {
      const response = await RoleService.getActiveRolesNew(profile, countryCode);
      if (response.data?.statusCode === 200) {
        setRoleOptions(response.data.response);
      } else {
        console.error("Error fetching roles:", response.data.message);
      }
    } catch (error) {
      setRoleOptions([])
      console.error("API call error:", error);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await CommonService.fetchCountries();
      if (response.data?.statusCode === 200) {
        setCountries(response.data.response);
      } else {
        console.error("Error fetching roles:", response.data.message);
      }
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name == "profile") {
      fetchRoles(value, selected?.countryCode);
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const isAllSelected =
    countries.length > 0 && selected.length === countries.length;

  const handleChangeCountry = (event) => {
    const option = event.target.value;
    fetchRoles(formData.profile, option.countryCode);
    if (option[option.length - 1] === "all") {
      setSelected(selected.length === countries.length ? [] : countries);
      // Update formData to reflect selected or deselected countries
      setFormData((prevFormData) => ({
        ...prevFormData,
        cropStageCountryDetail:
          selected.length === countries.length ? [] : countries,
      }));
      return;
    }

    setSelected(option);
    setFormData((prevFormData) => ({
      ...prevFormData,
      cropStageCountryDetail: option,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData?.profile == "Local" && selected?.length < 1) {
      setSeverity('error')
      setMessage("Country and Remarks field are mandatory");
      setOpenAlert(true);
      return
    }

    let countries_selected = [];
    if (formData.profile == "Global") {
      countries_selected = countries.map((country) => ({
        createdByUser: user?.userName || "Raju",
        modifiedByUser: user?.userName || "Raju",
        countryCode: country.countryCode,
        isDeleted: false,
        createdDateTimeUTC: new Date().toISOString(),
        modifiedDateTimeUTC: new Date().toISOString(),
      }))
    } else {
      countries_selected = [{
        createdByUser: user?.userName || "Raju",
        modifiedByUser: user?.userName || "Raju",
        countryCode: selected.countryCode,
        isDeleted: false,
        createdDateTimeUTC: new Date().toISOString(),
        modifiedDateTimeUTC: new Date().toISOString(),
      }]
    }
    try {
      // setErrors({});
      // await validationSchema.validate(formData, { abortEarly: false });
      console.log('selected', selected)
      // Constructing the payload object
      const payload = {
        profileName: formData.fieldTechnician,
        isActive: true,
        profileAttribute: formData.profile,
        serviceNumber: formData.serviceNumber,
        remarks: formData.remarks,
        isDeleted: false,
        profileOwnerId: formData.role,
        countries:countries_selected,
        createdByUser: user.userName,
        modifiedByUser: user.userName,
        createdDateTimeUTC: new Date().toISOString(),
        modifiedDateTimeUTC: new Date().toISOString(),

      };

      // Make a POST request using Axios
      setLoading(true)
      const response = await RoleService.createRole(payload);
      setLoading(false)

      if (response.status === 201) {
        // Show success snackbar
        navigate("/roleCreation");
        setSeverity("success");
        setMessage("Added successfully");
        setOpenAlert(true);
      } else {
        console.error("Failed to submit form");
        // Show error snackbar
        setSeverity("error");
        setMessage("Failed to submit form");
        setOpenAlert(true);
      }
    } catch (error) {
      setLoading(false)
      let newError = {};
      if (error?.name && error.name === "ValidationError") {
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
          setErrors(newError || error?.message);
          return;
        });
      } else {
        setSeverity("error");
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
      }
    }
  };

  return (
    <LayoutAccessManagement>
      <Box sx={{ paddingBottom: "150px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "65vh",
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "25px",
            borderRadius: "6px"
          }}
        >
          <Box
            sx={{
              background: "#ffffff",
              width: "443px",
              p: 2,
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              borderRadius: "16px",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",


            }}
          >
            <TextField
              select
              id="profile"
              label={t("profile")}
              value={formData.profile}
              name="profile"
              onChange={handleChange}
              fullWidth
            >
              {profileOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>

            {formData.profile !== "" && (
              <>
                <FormControl fullWidth>
                  {/* Render TextField with a Select dropdown */}
                  <TextField
                    select
                    required={false}
                    label={t("selectCountry")}
                    value={formData.profile == "Global" ? "all" : selected}
                    onChange={handleChangeCountry}
                  >
                    {formData.profile == "Global" &&
                      <MenuItem value="all" >
                        <ListItemText selected primary="Select All" />
                      </MenuItem>
                    }
                    {/* Loop through countries and create menu items */}
                    {countries.map((option) => (
                      <MenuItem disabled={formData.profile == "Global"} key={option.countryName} value={option}>
                        <ListItemText primary={option.countryName} />
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
                <TextField
                  label={t("addNewRole")}
                  name="fieldTechnician"
                  onChange={handleChange}
                  value={formData.fieldTechnician}
                />
              </>

            )}
            {formData.fieldTechnician !== "" && (
              <TextField
                select
                id="role"
                label={t("AssignRoleOwner")}
                value={formData.role}
                name="role"
                onChange={handleChange}
                fullWidth
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      sx: {
                        maxHeight: 200, // Limit dropdown height
                      },
                    },
                  },
                }}
              >
                {roleOptions.map((option) => (
                  <MenuItem
                    sx={{
                      maxHeight: "30px !important", // Control the height of individual items
                      fontSize: "16px", // Adjust font size for compact display
                    }}
                    key={option.id}
                    value={option.id}
                  >
                    {option.value}
                  </MenuItem>
                ))}
              </TextField>
            )}
            {formData.role !== "" && (
              <>


                {/* <Select
                  labelId="cropStageCountryDetail"
                  name="cropStageCountryDetail"
                   label="Select Country"
                  multiple
                  value={selected}
                  onChange={handleChangeCountry}
                  renderValue={(selected) =>
                    selected.map((select) => select.countryName).join(", ")
                  }
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 250,
                        overflowY: "auto",
                      },
                    },
                  }}
                >
                  <MenuItem value="all">
                    <ListItemIcon>
                      <Checkbox
                        checked={isAllSelected}
                        indeterminate={
                          selected.length > 0 &&
                          selected.length < countries.length
                        }
                        icon={<img src={CheckboxUntick} />}
                        checkedIcon={<img src={CheckboxTick} />}
                      />
                    </ListItemIcon>
                    <ListItemText primary="Select All" />
                  </MenuItem>
                  {countries.map((option) => (
                    <MenuItem key={option.countryName} value={option}>
                      <ListItemIcon>
                        <Checkbox
                          checked={selected.indexOf(option) > -1}
                          icon={<img src={CheckboxUntick} />}
                          checkedIcon={<img src={CheckboxTick} />}
                        />
                      </ListItemIcon>
                      <ListItemText primary={option.countryName} />{" "}
                    </MenuItem>
                  ))}
                </Select> */}
                <TextField
                  label={t("serviceNumber")}
                  name="serviceNumber"
                  onChange={handleChange}
                  value={formData.serviceNumber}
                />
                <TextField
                  label={t("remarks")}
                  name="remarks"
                  onChange={handleChange}
                  value={formData.remarks}
                  multiline
                  rows={4}
                />
                <Box
                  sx={{
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    gap: "20px",
                  }}
                >
                  <Button
                    sx={{
                      borderRadius: 2,
                      background: "#102A62",
                      height: 54,
                      color: "#ffffff",
                      fontWeight: 600,
                      backgroundColor: "#737D86",
                      width: { xs: "100%", md: "156px" },
                      "&:hover": {
                        backgroundColor: "#737D86",
                      },
                    }}
                    onClick={() => navigate("/roleCreation")}
                  >
                    {t("back")}
                  </Button>
                  <Button
                    sx={{
                      borderRadius: 2,
                      background: "#EF7D00",
                      color: "#ffffff",
                      fontWeight: 600,
                      height: 54,
                      width: { xs: "100%", md: "156px" },
                      "&:hover": {
                        backgroundColor: "#EF7D00",
                      },
                    }}
                    disabled={!formData?.remarks || (formData?.profile == "Local" && selected?.length < 1) ||
                       loading
                    }
                    onClick={handleSubmit}
                  >
                    {t("submit")}
                  </Button>
                </Box>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </LayoutAccessManagement>
  );
};

export default AddRole;
